import React from 'react';
import { Link } from 'react-router-dom';
import './header.scss';
import Navigation from './Navigation';
import ProfileNav from './ProfileNav';

const InitHeader = () => {
  return (
    <header className={`header header-box-shadow`}>
      <a href="/" className={'eepass-banner'} aria-label="EE PASS Home" title="EE PASS Home"></a>
      <div>&nbsp;</div>
      <div className={'eepass-banner'}></div>
    </header>
  );
}

export default InitHeader;